module.exports = __webpack_public_path__ + "img/icon_empt.fbbacd1e.png";